module.exports = __webpack_public_path__ + "static/media/result-icon.90d0d7b6.svg";